import React, { createRef } from 'react';
import { number, bool, string, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import Pagination from '../Pagination';

import styles from './CarouselPagination.css';

const cx = classnames.bind(styles);

export default class CarouselPagination extends Pagination {
  static propTypes = {
    ...Pagination.propTypes,
    autoplay   : bool,
    label      : string,
    size       : oneOf(['small', 'large']),
    timer      : number,
    vertical   : bool,
    dark       : bool,
    medium     : bool,
    responsive : bool,
    className  : string,
  };

  static defaultProps = {
    ...Pagination.defaultProps,
    autoplay: false,
    vertical: false,
    timer   : 5,
    size    : 'small',
  };
  
  circleRadius = 6;
  dots = [];
  dotsListRef = createRef();
  interval = null;
  totalDisplayItems = Math.min(this.props.totalItems, 8);

  componentDidMount = () => {
    const { currentPage } = this.state;
    const { autoplay } = this.props;
    this.dots = this.dotsListRef.current.querySelectorAll('li');
    
    setTimeout(() => this.updateActiveDot(currentPage));
    if (autoplay) { this.initTimer(); }
  }

  componentWillUnmount = () => {
    clearInterval(this.interval);
  }

  componentDidUpdate = () => {
    const { autoplay } = this.props;

    if (autoplay) {
      this.restartTimer();
    } else {
      clearInterval(this.interval);
    }

    this.updateActiveDot(this.state.currentPage);
  }

  initTimer = () => {
    const { timer } = this.props;

    this.interval = setInterval(() => this.handleNextPage(), timer * 1000);
  }

  restartTimer = () => {
    clearInterval(this.interval);
    this.initTimer();
  }

  updateActiveDot = page => {
    const { lastPage } = this.state;
    const activeDot = this.dots[page - 1];
    const lasActiveDot = this.dots[lastPage];

    if (lasActiveDot) {
      lasActiveDot.classList.remove(cx('activeDot'));
    } 
    activeDot.classList.add(cx('activeDot'));
  }

  /* eslint-disable react/display-name */
  dot = index => {
    const { timer } = this.props;
    const { currentPage } = this.state;

    const circleStyles = currentPage === index
    ? { 'transitionDuration': timer + 's' }
    : {};

    return (
      <li key={`dot-${index}`}  className={cx('dot')}>
        <a href="#" onClick={this.selectPage.bind(null, index)}>
          <svg width="14px" height="14px" viewBox="0 0 14 14">
            <circle
              className={cx('circle')}
              r={this.circleRadius}
              style={circleStyles}
            />
            <circle className={cx('circleCenter')} r="2" />
          </svg>
        </a>
      </li>
    );
  }

  renderLabel = () => {
    const { label, size, vertical, responsive } = this.props;

    let labelClass = responsive
      ? cx('responsive')
      : size === 'large'
        ? 'p'
        : 'tag';
    
    return label && vertical ?
      <label className={labelClass}>
        { label }
      </label>
      : null;
  }

  renderDots = () => {
    const dots = [];

    for (let i = 1; i <= this.totalDisplayItems; i++) {
      dots.push(this.dot(i));
    }

    return dots;
  }

  render() {
    const { totalDisplayItems, vertical, autoplay, dark, medium, className } = this.props;

    if (totalDisplayItems < 2) { return null; }

    const listClasses = cx('dotsList', { vertical, autoplay, dark, medium });

    return (
      <div className={cx('carouselPagination', className)}>
        { this.renderLabel() }
        <ul
          className={listClasses}
          ref={this.dotsListRef}
          onKeyDown={this.onKeyPressed}
        >
          { this.renderDots() }
        </ul>
      </div>
    );
  }
}

CarouselPagination.displayName = 'CarouselPagination';



// WEBPACK FOOTER //
// ./src/uis/elements/Pagination/CarouselPagination/CarouselPagination.js